import React from 'react';
import './index.scss';
import ACTImage from '../../../images/taking-asthma-control-test.svg';
import QuestionImage from '../../../images/group-of-question-marks.svg';

const Instructions = (props)=> {
  return (

	<div className="screen instructions">
		<img className="actImage" src={ACTImage} alt="Taking Asthma Control Test" />
		<form onSubmit={props.formHandler} className="actView fadeIn">
			<div className="question">
				<img className="questionImage" src={QuestionImage} alt="Icon: Group of Question Marks" />
				<p className="quote">How to take the Asthma Control Test&trade;</p>
				<dl>
					<dt className="dsc">Step 1</dt>
					<dd className="base-copy">Answer the five questions asked. For each question, make sure you read all five possible answers before choosing the best one for you.</dd>

					<dt className="dsc">Step 2</dt>
					<dd className="base-copy">Complete the test by clicking <strong>'SUBMIT.'</strong></dd>

					<dt className="dsc">Step 3</dt>
					<dd className="base-copy">Take the COMPLETED test to your healthcare provider to talk about your score.</dd>
				</dl>
			</div>
			<button className="prev" type="button" onClick={props.restartHandler}><span className="hide-sm">Back</span></button>
			<button className="next" type="submit">Begin the Test</button>
		</form>
	</div>
  );
}

export default Instructions;
